import { render, staticRenderFns } from "./Vat.vue?vue&type=template&id=bf254ff4&scoped=true&"
import script from "./Vat.vue?vue&type=script&lang=js&"
export * from "./Vat.vue?vue&type=script&lang=js&"
import style0 from "./Vat.vue?vue&type=style&index=0&id=bf254ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf254ff4",
  null
  
)

export default component.exports